<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div class="position-relative"  *ngIf="summaryData">
    <button class="fa fa-times pull-right summary_modal_close_btn" [mat-dialog-close]=""
        style="cursor: pointer;background: none;" aria-hidden="true"></button>
        <app-progress-bar [isLoading]="summeryLoading"></app-progress-bar>
    <p-table [value]="summaryData" styleClass="p-datatable-gridlines" class="summary_modal_table" [scrollable]="true" scrollHeight="700px">
    
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 70px;">Id</th>
                <th>Summary Versions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-summary>
            <tr>
                <td style="width: 70px;">{{summary.id}}</td>
                <td>
                    <div class="summary_value">
                        <p [innerHTML]="showText(summary.value)"></p>
                        <button class="btn" (click)="onCloseDialog(summary.id)">select</button>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="summary-footer d-flex align-items-center">
                <span><button (click)="onCloseDialog()" class="btn">Cancel</button></span>
                <span><button (click)="generateSummary()" class="btn" [disabled]="isGenerateDisabled">Generate</button></span>
            </div>
        </ng-template>
    </p-table>
</div>